declare var jQuery: any;

const clampQuantityInput = ($input: any): void => {
    const min = parseInt($input.attr('min'), 10) || 1;
    const maxAttr = $input.attr('max');
    const max = maxAttr ? parseInt(maxAttr, 10) : 0;
    let val = parseInt($input.val(), 10);

    if (isNaN(val) || val < min) {
        $input.val(min);
        return;
    }

    if (max > 0 && val > max) {
        $input.val(max);
    }
};

const initQuantityInputs = (context?: string | Document | Element): void => {
    const $scope = context ? jQuery(context) : jQuery(document);
    $scope.find('.quantity input.qty').each(function (this: HTMLElement) {
        clampQuantityInput(jQuery(this));
    });
};

const getQuantityInputFromControl = ($control: any): any => {
    const $quantity = $control.closest('.quantity');
    if ($quantity.length) {
        return $quantity.find('input.qty');
    }
    return $control.siblings('input.qty');
};

jQuery(document).ready(() => {
    initQuantityInputs();

    jQuery(document).on('change input blur', '.quantity input.qty', function (this: HTMLElement) {
        clampQuantityInput(jQuery(this));
    });

    jQuery(document).on('keydown', '.quantity input.qty', function (this: HTMLElement, e: KeyboardEvent) {
        const $input = jQuery(this);
        const min = parseInt($input.attr('min'), 10) || 1;
        const val = parseInt($input.val(), 10) || min;

        if (e.key === 'ArrowDown' && val <= min) {
            e.preventDefault();
            $input.val(min);
        }
    });

    jQuery(document).on('click', '.quantity .minus, .quantity .qty-minus, .quantity button.minus', function (this: HTMLElement, e: Event) {
        const $input = getQuantityInputFromControl(jQuery(this));
        if (!$input.length) {
            return;
        }

        const min = parseInt($input.attr('min'), 10) || 1;
        const val = parseInt($input.val(), 10) || min;

        if (val <= min) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $input.val(min);
            return false;
        }
    });

    jQuery(document).on('found_variation', 'form.cart', function (_e: any, variation: any) {
        const $qty = jQuery(this).find('.quantity input.qty');

        if (variation.min_qty) {
            $qty.attr('min', variation.min_qty);
        }

        clampQuantityInput($qty);
    });

    jQuery(document.body).on('updated_cart_totals updated_wc_div', () => {
        initQuantityInputs();
    });

    jQuery(document).on('click', '.load-add-to-cart', () => {
        setTimeout(() => initQuantityInputs('#addToCartSideNav'), 300);
    });
});
